module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-6d341183a3616b264c466772b114afb8.jpg";